import { render } from "./proforma-invoices.vue?vue&type=template&id=659f85a3&scoped=true"
import script from "./proforma-invoices.vue?vue&type=script&lang=js"
export * from "./proforma-invoices.vue?vue&type=script&lang=js"

import "./proforma-invoices.vue?vue&type=style&index=0&id=659f85a3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-659f85a3"]])

export default __exports__